import { getHeaderContent } from '../../utils/background';

export const UPDATE_HEADER_CONTENT = 'UPDATE_HEADER_CONTENT';
const updateHeaderImageAction = (payload) => ({
    type: UPDATE_HEADER_CONTENT,
    payload,
});

export const updateHeaderImage = () => (dispatch, getState) => {
    const {
        content: { seasonal },
        headerImageIndex,
        app: { tld },
    } = getState();

    const payload = getHeaderContent({
        seasonalContent: seasonal,
        fixedImageIndex: headerImageIndex,
        tld,
    });

    dispatch(updateHeaderImageAction(payload));
};
